import React from 'react';
import { Route, Routes } from 'react-router';
import HomePage from './Pages/Home';
import SchedulerTCM from './Pages/tcm';
// import ThankYouPage from './Pages/Home/ThankYouPageNew';

function AppRouter() {
    return (
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/tcm" element={<SchedulerTCM/>} />
        {/* <Route path="/thank-you-work/:paymentId" element={<ThankYouPage/>} /> */}
      </Routes>
    );
  }
  
  export default AppRouter;